// src/pages/BienvenidaMobile.jsx
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import ClientLayoutMobile from '../components/ClientLayoutMobile'; // 🔑 Usar layout móvil
import { useNavigate } from 'react-router-dom';

const COLOR_SIERRA_GREEN = '#2E5B2E'; 
const COLOR_CANTERA_PINK = '#C19A6B'; 
const COLOR_CHARCOAL = '#333333';
const COLOR_SOFT_CREAM = '#F9F9F5';
const COLOR_WHITE = '#FFFFFF';
const COLOR_RED = '#DC2626';

// Componente Auxiliar: Tarjeta de Acceso
const ClientMenuCardMobile = ({ icon, title, desc, onClick, color }) => (
    <div 
        onClick={onClick}
        style={{ 
            background: COLOR_SOFT_CREAM,
            padding: 15, 
            borderRadius: 12, 
            width: '100%', // Ancho completo
            textAlign: 'center', 
            cursor: 'pointer', 
            border: color ? `2px solid ${color}` : `1px solid ${COLOR_SOFT_CREAM}`, 
            transition: 'transform 0.2s', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0,0,0,0.05)', 
            minHeight: 120, 
            color: COLOR_CHARCOAL
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
    >
        <div style={{ fontSize: 30, marginBottom: 5, color: color || COLOR_SIERRA_GREEN }}>{icon}</div> 
        <div style={{ fontSize: 14, fontWeight: 'bold', color: COLOR_CHARCOAL, marginBottom: 2 }}>{title}</div> 
        <p style={{ fontSize: 10, color: COLOR_CHARCOAL, margin: '0' }}>{desc}</p> 
        <span style={{ fontSize: 10, fontWeight: 'bold', color: COLOR_WHITE, background: color || COLOR_SIERRA_GREEN, padding: '2px 8px', borderRadius: 4, marginTop: 5 }}>
            GO
        </span>
    </div>
);


function BienvenidaMobile() {
    const navigate = useNavigate();

    // Solo necesitamos los estilos de estructura
    const GRID_WRAPPER_STYLE = { 
        display: 'grid', // Usamos grid para 2 columnas
        gridTemplateColumns: '1fr 1fr', 
        gap: 15, 
        maxWidth: 400, 
        width: '100%', 
        padding: '0 15px' 
    };

    const LOGO_TEXT_STYLE = {
        color: COLOR_CANTERA_PINK, 
        marginBottom: 30, 
        fontSize: 20, 
        textAlign: 'center',
        padding: '0 15px'
    }

    return (
        <ClientLayoutMobile>
            <h2 style={LOGO_TEXT_STYLE}>Menú Cliente</h2>
            <div style={GRID_WRAPPER_STYLE}>
                
                {/* 1. Hacer Pedido */}
                <ClientMenuCardMobile 
                    icon="📝" 
                    title="Hacer Pedido" 
                    desc="Solicita tu nuevo envío de café." 
                    onClick={() => navigate('/solicitud-pedido')} 
                    color={COLOR_SIERRA_GREEN} 
                />
                
                {/* 2. Pagos y Saldo */}
                <ClientMenuCardMobile 
                    icon="💰" 
                    title="Pagos y Saldo" 
                    desc="Consulta tu estado de cuenta." 
                    onClick={() => navigate('/pagos')} 
                    color={COLOR_CANTERA_PINK} 
                />
            </div>

            <div style={{marginTop: 30, color: COLOR_SOFT_CREAM, fontSize: 12, textAlign: 'center', padding: '0 20px'}}>
                Tu plataforma de logística simplificada de Xavana Café.
            </div>
        </ClientLayoutMobile>
    );
}
export default BienvenidaMobile;